// https://vuex.vuejs.org/en/getters.html

export default {
  name: state => state.name,
  message: state => state.message,
  data: state => state.data,
};
